import CctvSvg from '@assets/images/svg/cctv.svg';
import React from 'react';
import { View } from 'react-native';

export interface CctvIconProps {
    size?: number;
    color?: string;
}

export function CctvIcon({ size = 24, color = '#4D4D4D' }: CctvIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CctvSvg width={size} height={size} color={color} />
        </View>
    );
}

export default CctvIcon;
